import {FieldType, type FullFieldFragment} from '@transactions/graphql';
import {Pencil, Trash2} from 'lucide-react';
import {Button} from 'src/Button';
import {useModals} from 'src/Modals';

type Props = {
  field: FullFieldFragment;
  onUpdate: () => void;
};

export const FieldCard = (props: Props) => {
  const {field, onUpdate} = props;
  const {editFieldModal, deleteFieldModal} = useModals();

  const handleEdit = () => {
    editFieldModal.openModal({field, onSuccess: onUpdate});
  };

  const handleDelete = () => {
    deleteFieldModal.openModal({field, onDeleted: onUpdate});
  };

  return (
    <div className="border-border bg-card rounded-lg border p-4">
      <div className="mb-3 flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h3 className="font-medium">{field.name}</h3>
            <span className="rounded bg-muted px-1.5 py-0.5 text-xs font-medium capitalize text-muted-foreground">
              {field.type}
            </span>
            {field.required && (
              <span className="bg-destructive/10 text-destructive rounded px-1.5 py-0.5 text-xs">
                Required
              </span>
            )}
            {field.allowMultiple && (
              <span className="rounded bg-primary/10 px-1.5 py-0.5 text-xs text-primary">
                Multi-select
              </span>
            )}
          </div>
          {field.description && (
            <p className="text-muted-foreground mt-1 text-sm">
              {field.description}
            </p>
          )}
        </div>
        <div className="flex gap-1">
          <Button size="icon" variant="ghost" onClick={handleEdit}>
            <Pencil className="h-4 w-4" />
          </Button>
          <Button size="icon" variant="ghost" onClick={handleDelete}>
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>

      {field.type === FieldType.Enum && (
        <div className="border-border border-t pt-3">
          <div className="text-muted-foreground mb-2 text-sm font-medium">
            Values
          </div>
          <div className="flex flex-wrap gap-2">
            {field.values.map((v) => (
              <div
                key={v.value}
                className="border-border bg-muted rounded-md border px-2 py-1 text-sm"
                title={v.description || undefined}
              >
                {v.value}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
